import React from 'react';

import { FontSize } from '@common/tokens';

export const LabeledText = ({
  label,
  text,
  orientation = 'horizontal',
}: {
  label: string;
  text: string | React.ReactNode;
  orientation?: 'horizontal' | 'vertical';
}) => (
  <div className="LabeledText">
    <label className={orientation === 'vertical' ? 'display-block' : ''}>
      {label}:
    </label>
    <span>{text}</span>
    <style jsx>{`
      .LabeledText label {
        font-weight: bold;
        margin-right: 0.2rem;
        font-size: ${FontSize.md};
      }

      .LabeledText label.display-block {
        display: block;
      }
    `}</style>
  </div>
);
